import styled from 'styled-components';
import Creatable from 'react-select/creatable';

import colors from 'themes/Main';

const { gray01, gray03, gray04, gray05 } = colors;

const customStyles = {
  control: (base, { isDisabled }) => ({
    ...base,
    width: '100%',
    height: '40px',
    backgroundColor: isDisabled ? `${gray05}` : 'transparent',
    opacity: isDisabled ? '0.6' : '',
    padding: '0 4px',
    border: `1px solid ${gray03}`,
  }),
  input: () => ({
    color: `${gray01}`,
    fontSize: 14,
  }),
  placeholder: defaultStyles => ({
    ...defaultStyles,
    color: `${gray04}`,
    fontSize: 14,
  }),
  dropdownIndicator: () => ({
    color: `${gray03}`,
    marginTop: '-3px',
    marginLeft: '3px',
  }),
  singleValue: () => ({
    fontSize: 14,
    color: `${gray01}`,
  }),
};

export const CreatableSelect = styled(Creatable).attrs({
  styles: customStyles,
})``;
